export default __webpack_public_path__ + "static/SRUS LF410 - Especification Del Producto y Datos Técnicos-ad48a78a09179f9d3d2a6348ea553bfd.pdf";